<template>
  <v-tooltip
    bottom 
    :disabled="!tooltip"
  >
    <template #activator="{ on, attrs }">
      <v-avatar
        v-bind="attrs"
        class="no-select"
        :style="`background-color:${colorGenerator(userInitials)}`"
        v-on="on"
      >
        <span class="text-white h5 m-0">{{ userInitials }}</span>
      </v-avatar>
    </template>
    <div class="text-center my-1">
      <div class="h6">
        {{ fullName }}
      </div>
      <p class="text-caption my-0">
        {{ secondaryText }}
      </p>
    </div>
  </v-tooltip>
</template>
<script>
import getInitials from "../utils/getInitials";
export default {
    props:{
        fullName:{
            type:String,
            required:true
        },
        secondaryText:{
            type:String,
            default:''
        },
        tooltip:{
          type:Boolean,
          default:false
        }
    },
    computed:{
        userInitials(){
            return this.getInitials(this.fullName);
        }
    },
    methods:{
        getInitials,
        colorGenerator(string){
            const firstLetter = (`${[...string][0]}`.charCodeAt(0) - 97)*10
            const secondLetter = (`${[...string][1]}`.charCodeAt(0) - 97)*4
            return `hsl(${firstLetter - secondLetter},35%,58%)`
        }
    }
}
</script>
<style>
.no-select{
  -webkit-touch-callout: none; 
  -webkit-user-select: none; 
  -khtml-user-select: none; 
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>